import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import Clickable, { ClickableProps } from "@insite/mobius/Clickable";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemStyle } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link, { StyledIcon } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal/Modal";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Msq from "@MasterBluePrint/Components/Msq";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";


const enum fields {
    availableForRentTitle = "availableForRentTitle",
    availableForRentLinkText = "availableForRentLinkText",
    availableForRentLink = "availableForRentLink",
    scriptSrc = "scriptSrc",
    formID = "formID",
    loadFormParam1 = "loadFormParam1",
    loadFormParam2 = "loadFormParam2",
    loadFormParam3 = "loadFormParam3",
}



interface OwnProps extends WidgetProps {
    fields: {
        [fields.availableForRentTitle]: string;
        [fields.availableForRentLinkText]: string;
        [fields.availableForRentLink]: string;
        [fields.scriptSrc]: string;
        [fields.formID]: string;
        [fields.loadFormParam1]: string;
        [fields.loadFormParam2]: string;
        [fields.loadFormParam3]: string;
    };
}


type Props = OwnProps & HasProduct;

export interface AvailableForRentStyle {
    availableForRentMainContainer?: InjectableCss;
    availableForRentModal?: InjectableCss;
    availableForRentHeading?: InjectableCss;
    availableForRentLink?: InjectableCss;
    closeContainer?: InjectableCss;
    cancelButton?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export const minMulQtyStyles: AvailableForRentStyle = {
    availableForRentMainContainer: {
        css: css`
            background-color: #fff;
            font-weight: 600;
            font-size: .85rem;
            margin-bottom: .2em;
            margin-top: 3.063rem;
            text-align: center;
            > div {
                background-color: #fff;
                box-shadow: 0 0 0px 10px #fff;
                padding: .625rem 0;
                justify-content: center;
            }
        `,
    },
    availableForRentHeading: {
        css: css`
            color: #333F48;
            font-family: 'Roboto', sans-serif;
            font-size: 1.25rem;
            font-weight: 500;
            letter-spacing: -.024rem;
            line-height: 1.4375rem;
            margin-bottom: .31250625rem;
            width: 100%;
        `,
    },
    availableForRentLink: {
        css: css`
            color: #333F48;
            font-family: Lato;
            font-size: .875rem;
            letter-spacing: 0;
            line-height: 1.5rem;
            text-decoration: underline;

            span {
                color: #333F48 !important;
            }
        `,
    },
    availableForRentModal: {
        css: css`
            margin-top: 0;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: center;
            justify-content: center;
            height: 100%;
            animation: 300ms ease 0s 1 normal none running fUZMVa;

            &.available-rent-modal {
                #modalTitle {
                    display: none;
                }

                @media screen and (min-width: 768px) {
                    > div  {
                        height: auto;
                        max-height: calc(100% - 90px);
                        margin: 2.8125rem;
                        max-width: 31.25rem;
                        box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
                        background: #fff;
                    }
                }
            }

            > div > div {
                position: relative;
            }

            > div > div > div {
                min-height: 170px;
            }

            form.mktoForm .mktoButtonRow {
                border-top: 1px solid rgba(215, 215, 215, .72);
                padding-top: .9375rem;
            }

            h1 {
                color: #333F48;
                font-family: 'Roboto', sans-serif;
                font-size: 1.25rem;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 2rem;
                position: relative;
                margin-top: 1.5625rem;

                &:after {
                    height: .125rem;
                    width: 2.75rem;
                    background-color: #C63527;
                    content: '';
                    display: inline-block;
                    position: absolute;
                    bottom: -.75rem;
                    left: .0625rem;
                }
            }

            form.mktoForm button.mktoButton {
                float: right;

                @media screen and (max-width: 767px) {
                    float: none;
                }
            }

            .mktoRequiredField .mktoAsterix{
                font-size: .9375rem !important;
                display: block !important;
                color: #535E64 !important;
            }

            .mktoLabel {
                color: #535E64 !important;
                font-family: 'Roboto', sans-serif;
                font-size: .9375rem;
                font-weight: 500 !important;
                letter-spacing: .012rem;
                line-height: 1.4375rem;

                b,
                strong,
                span {
                    color: #535E64 !important;
                    font-family: 'Roboto', sans-serif;
                    font-size: .9375rem;
                    font-weight: 500 !important;
                    letter-spacing: .012rem;
                }

                em {
                    // display: none !important;
                    padding-left: 0; 
                    padding-right: 0; 
                }
            }

            .mktoFormCol {
                margin-bottom: .625rem !important;
            }

            form.mktoForm .mktoRadioList label[for], 
            form.mktoForm .mktoCheckboxList label[for] {
                padding: 0 0 .9em 1.75em !important;
            }

            form {
                padding: 35px 0 20px 0;

                &.mktoForm {
                    padding: 35px 0 20px 0;
                }
            }

            form.mktoForm input[type=url], 
            form.mktoForm input[type=text], 
            form.mktoForm input[type=date], 
            form.mktoForm input[type=tel], 
            form.mktoForm input[type=email], 
            form.mktoForm input[type=number], 
            form.mktoForm textarea.mktoField, 
            form.mktoForm select.mktoField {
                height: 2.5rem;
                border: 1px solid #CECECE;
                border-radius: .125rem;
                background-color: #fff;
                min-height: 2.5rem;
            }
        `,
    },
    cancelButton: {
        css: css`
            color: #002554;
            font-family: 'Roboto', sans-serif;
            font-size: .9375rem;
            letter-spacing: 0;
            line-height: 1.3125rem;
            text-align: center;
            text-decoration: underline;
            cursor: pointer;
            margin-left: 3em;
            margin-right: 3em;
            justify-content: center;
            width: auto;
            position: absolute;
            bottom: 3.875rem;

            @media screen and (max-width: 767px) {
                position: static;
                margin: .9375rem auto 0;
            }
        `,
    },
    closeContainer: {
        css: css`
           cursor: pointer;
           position: absolute;
           right: 1.25rem;
           top: 1.5rem;
           .close-label {
                color: #535E64;
                font-family: 'Roboto', sans-serif;
                font-size: .875rem;
                letter-spacing: .01rem;
                line-height: 1;
                display: inline-block;
                margin-right: .625rem;
                vertical-align: middle;
           }
           .icon-close {
                display: inline-block;
                cursor: pointer;
                vertical-align: middle;
                line-height: 1;
                width: 1.125rem;
                height: 1.125rem;
                svg {
                    height: 1.125rem;
                    width: 1.125rem;
                }
            }
        `,
    },
    spinner: {
        css: css`
            margin: 1.5rem auto;
            display: block;
        `,
    }
};

const styles = minMulQtyStyles;

const AvailableForRent: React.FC<Props> = ({ fields, product }) => {
    if (product.properties.availableForRent === undefined) {
        return null;
    }
    if (product.properties?.availableForRent.toLowerCase() === "true") {
        const availableForRent = () => {
            setIsavailableForRentModalOpen(true);
            document.getElementById("triangle")?.toggleAttribute("hidden");
            document.getElementById("form")?.toggleAttribute("hidden");
            document.getElementById("overlay")?.toggleAttribute("hidden");
            document.getElementById("formLoadingSpinner")!.style.display = "block";
        };
        const [isavailableForRentModalOpen, setIsavailableForRentModalOpen] = useState(false);
        const onAvailableForRentClose = () => {
            setIsavailableForRentModalOpen(false);
        };


        const [isLoaded, setIsLoaded] = useState(false);
        const marketoScriptId = 'mktoForms';
        const formId = fields.loadFormParam3;
        useEffect(() => {
            if (!document.getElementById(marketoScriptId)) {
                loadScript();
            } else {
                setIsLoaded(false);
            }
        }, []);

        useEffect(() => {
            const scriptCall = document.createElement("script");
            scriptCall.innerHTML =
                `MktoForms2.loadForm("${fields.loadFormParam1}", "${fields.loadFormParam2}", "${fields.loadFormParam3}");
             MktoForms2.whenReady(function(mktoForm){
                const defaultValues = {
                    buy1Mod : "${product.productNumber}",                  
                };
              
                let currentValues = mktoForm.getValues();
              
                let finalValues = Object.keys(defaultValues)
                  .reduce(function(acc,key){
                     if( !currentValues[key] ) {
                       acc[key] = defaultValues[key];
                     }
                     return acc;
                  },{});
              
                mktoForm.setValues(finalValues);        
              });
              MktoForms2.whenReady(function(mktoForm){
                document.getElementById("formLoadingSpinner").style.display = "none";
              });
              `;
            document.body.appendChild(scriptCall);
        }, [isLoaded, formId, isavailableForRentModalOpen]);

        const loadScript = () => {
            const s = document.createElement('script');
            s.id = marketoScriptId;
            s.type = 'text/javascript';
            s.async = true;
            s.src = fields.scriptSrc;
            s.onload = () => setIsLoaded(true);
            document.getElementsByTagName('head')[0].appendChild(s);
        };
        
        return (
            <GridContainer {...styles.availableForRentMainContainer}>
                <Typography as="h5" {...styles.availableForRentHeading}>
                    {fields.availableForRentTitle}
                </Typography>
                <Typography as="div">
                    <Link
                        type="button"
                        onClick={availableForRent}
                        data-test-selector="availableForRent"
                        {...styles.availableForRentLink}
                    >
                        {fields.availableForRentLinkText}
                    </Link>
                    <Modal
                        isOpen={isavailableForRentModalOpen}
                        handleClose={() => onAvailableForRentClose()}
                        data-test-selector="availableForRentModal"
                        {...styles.availableForRentModal}
                        className="available-rent-modal"
                    >
                        <Typography as="div" onClick={onAvailableForRentClose} {...styles.closeContainer}>
                            <span className="close-label">Close</span>
                            <Icon className="icon-close" src="X" />
                        </Typography>
                        <div className="container">
                            <h1>Rental Inquiry</h1>
                            <LoadingSpinner {...styles.spinner} id="formLoadingSpinner"/>
                            <form id={`mktoForm_${formId}`}></form>
                            <Clickable onClick={onAvailableForRentClose} {...styles.cancelButton}>{translate("Cancel")}</Clickable>
                        </div>

                    </Modal>
                </Typography>
            </GridContainer>
        );
    }
    return <></>;
};

const widgetModule: WidgetModule = {
    component: withProduct(AvailableForRent),
    definition: {
        displayName: "Available For Rent",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.availableForRentTitle,
                editorTemplate: "TextField",
                defaultValue: "Rent Instead",
                fieldType: "Translatable",
            },
            {
                name: fields.availableForRentLinkText,
                editorTemplate: "TextField",
                defaultValue: "Click here for more information",
                fieldType: "Translatable",
            },
            {
                name: fields.availableForRentLink,
                editorTemplate: "TextField",
                defaultValue: "/",
                fieldType: "General",
            },
            {
                fieldType: "General",
                name: fields.scriptSrc,
                editorTemplate: "TextField",
                displayName: "Script Src",
                defaultValue: "//app-sj04.marketo.com/js/forms2/js/forms2.min.js",
            },
            {
                fieldType: "General",
                name: fields.formID,
                editorTemplate: "TextField",
                displayName: "Form ID",
                defaultValue: "mktoForm_5494",
            },
            {
                fieldType: "General",
                name: fields.loadFormParam1,
                editorTemplate: "TextField",
                displayName: "Load Form Param 1",
                defaultValue: "//app-sj04.marketo.com",
            },
            {
                fieldType: "General",
                name: fields.loadFormParam2,
                editorTemplate: "TextField",
                displayName: "Load Form Param 2",
                defaultValue: "313-KJQ-147",
            },
            {
                fieldType: "General",
                name: fields.loadFormParam3,
                editorTemplate: "TextField",
                displayName: "Load Form Param 3",
                defaultValue: "5494",
            },

        ],

    },
};
export default widgetModule;